import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { DateSyncService } from '@frontend/util/date-cohort-service';
import { CxAirTokenExpiryInterceptor } from '@frontend/util/interceptors';
import {
  NavItemAccessService,
  NavItemService,
} from '@frontend/util/nav-item-access';
import { BannerContainerComponent } from '@terminus-ui/banner';
import { AuthService, TsAuthModule } from 'auth';
import { CustomerMetadataApi } from 'customer-metadata-api';
import { DataDogService } from 'datadog';
import { EntitlementsService } from 'entitlements';
import { FullStoryService } from 'fullstory';
// import { GainsightService } from 'gainsight';
import { GlobalPanelModule } from 'global-panel';
import { JobStatuses } from 'job-status-api';
import { DataContextService, FeaturesLakeFrontV2Service } from 'lake-front-v2';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { SplitIoService } from 'split-io';
import { StatReporterService } from 'stats-reporting';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    TsAuthModule,
    RouterModule.forRoot(appRoutes, { initialNavigation: 'enabledBlocking' }),
    MatDialogModule,
    BannerContainerComponent,
    GlobalPanelModule,
    ToastModule,
    ButtonModule,
  ],
  providers: [
    AuthService,
    MessageService,
    DateSyncService,
    {
      provide: Window,
      useValue: window,
    },
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([CxAirTokenExpiryInterceptor]),
    ),
    NavItemAccessService,
    SplitIoService,
    // GainsightService,
    StatReporterService,
    DataContextService,
    FeaturesLakeFrontV2Service,
    JobStatuses,
    CustomerMetadataApi,
    FullStoryService,
    DataDogService,
    NavItemService,
    EntitlementsService,
  ],
})
export class AppModule {}
